module.exports = __webpack_public_path__ + "static/img/qrcode_kf.5d03187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basic/qrcode_kf.png
// module id = bEBS
// module chunks = 0